
import "./App.css";
import Layout from "./components/layout";
import Routers from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { TOKEN_KEY } from "./config/variable";
import "react-loading-skeleton/dist/skeleton.css";


function App() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const storageType = urlParams.get("storageType");
    const data = urlParams.get("data");

    // If we have fresh login data in the URL, always prefer it and override
    if (data && data !== "undefined" && storageType) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(data));

        // Clear any existing auth data so the new login (and storageType)
        // always take effect, even if a previous login was stored.
        localStorage.removeItem(TOKEN_KEY);
        sessionStorage.removeItem(TOKEN_KEY);

        if (storageType === "localStorage") {
          localStorage.setItem(TOKEN_KEY, JSON.stringify(parsedData));
        } else {
          sessionStorage.setItem(TOKEN_KEY, JSON.stringify(parsedData));
        }

        // Remove query params and reload so the app picks up the new token
        window.history.replaceState({}, document.title, "/");
        window.location.reload();
        return;
      } catch (error) {
        console.error("Failed to parse JSON data:", error);
        // On error, clean up URL and send user to login
        window.history.replaceState({}, document.title, "/login");
        window.location.href = "/login";
        return;
      }
    }

    const isSavedInStorage =
      localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

    if (!isSavedInStorage && (storageType || data)) {
      // No valid token and invalid URL params – just clean the URL
      console.warn("Invalid data or storageType:", { data, storageType });
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return <Routers />;
}

export default App;
